import React, { Component } from 'react'
import styled from 'styled-components'
import geolib from 'geolib'
import { upperlower, isAdmin, filterHiddenData, checkPostalCode, getAverageData } from '../utlis/functions'
import {
  WarningCard,
  Header,
  Footer,
  TopSection,
  DefaultText,
  PageWrapper,
  Card,
  Favorite,
  SecondaryHeader,
  ProgressBar,
  FlexWrapper,
  StyledImage,
  XLMText,
  XMText,
  XXLText,
  Icon,
  CustomSlider,
  XLMMText,
  XXMText,
  Tabber,
  Circle,
  Tab,
  Sale,
  Modal,
  Shape,
  Tooltip,
  Button,
  TextField,
  FormikForm,
  Counter,
  Toast,
  StyledFlex,
  ListView,
  PieChart,
  TextOverflow,
  XCMText,
  ImageModal,
  XXXLText,
  Hidden
} from '../components'
import { Formik, Field } from 'formik'
import { addList } from '../utlis/validators'
import { priceRangeCalculator } from '../utlis/functions'
import axios from 'axios'
import { API_URL } from '../constants'
import {
  flatten,
  filter,
  uniqBy,
  flatMap,
  indexOf,
  capitalize,
  get,
  sum,
  round,
  pickBy,
  toUpper,
  isEmpty,
  map,
  join,
  intersection,
  lowerCase,
  omit,
  values,
  size,
  min,
  max
} from 'lodash'
import lodashMap from 'lodash/map'
import truncate from 'lodash/truncate'
import Cookies from 'js-cookie'
import qs from 'qs'
import { gsCalculator, roundingValue } from '../utlis/functions'
import { geolocated } from 'react-geolocated'

const BugBox = styled.div`
  margin-top: 20px;
  svg {
    width: 20px;
    height: 20px;
    path {
      fill: ${props => (props.fillBug.length > 0 ? '#078489' : '#9a9a9a')}!important;
    }
  }
`
const FlexChild = styled.div`
  height: 100%;
  justify-content: space-between;
  & > div:first-child {
    flex-basis: 20%;
  }
  & > div:nth-child(2) {
    flex-basis: 60%;
    display: flex;
    justify-content: center;
  }
  & > div:last-child {
    flex-basis: 20%;
  }
`
const CardParent = styled.div`
  position: relative;
`

/* const DietaryModalWrapper = styled.div`
  display: flex;
  padding-top: 10px;
` */
class SingleProduct extends Component {
  state = {
    isImgPreviewOpen: false,
    isLoading: false,
    userData: null,
    productData: {},
    favorite: false,
    selectedTab: '',
    showModal: false,
    openList: false,
    createNew: false,
    listExist: false,
    openToast: false,
    openToast2: false,
    favouriteData: 0,
    shoppingLists: [],
    productsCount: 0,
    shoppingData: {},
    valuesData: [],
    choosenProduct: '',
    bugReported: false,
    touched: false,
    bugReportModal: false,
    bugFill: false,
    shareModal: false,
    bugCount: 0,
    dietaryWarningCard: true,
    showWarningPopUp: false,
    zipcodeWarningCard: false,
    selectedStores: [],
    toggleImage: {}
  }
  async componentDidMount() {
    window.scrollTo(0, 0)
    const recievedState = get(this.props, 'location.state', {})
    this.setState({ recievedState })
    await this.setState({ selectedStores: Cookies.getJSON('selectedStores') })
    await this.getuserData()
    this.getFavouriteData()
    this.getAllFavouriteData()
    this.getBugReport()
    this.getProduct()
    const query = {
      filter: {
        include: ['greenScores', { productCost: ['grocer'] }, 'gsDescriptions', 'users']
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/ProductTables/${this.props.match.params.tab}?${qs.stringify(query)}`)

      const newData = await Promise.all(
        map(data.productCost, async costItem => {
          if (get(costItem, 'grocer.grocerType', '') !== 'Online' && get(this.props, 'coords.latitude', null)) {
            const { data: distance } = await axios.get(
              `${API_URL}/grocers/distance/${this.props.coords.latitude},${this.props.coords.longitude}/${get(
                costItem,
                'grocer.storeName',
                costItem.storeName
              ).replace('Insta_', '')}`
            )

            if (distance.geo) {
              return {
                ...costItem,
                grocer: {
                  ...costItem.grocer,
                  distance: geolib.getDistance(
                    {
                      latitude: distance.geo.location.lat,
                      longitude: distance.geo.location.lng
                    },
                    { latitude: this.props.coords.latitude, longitude: this.props.coords.longitude }
                  )
                }
              }
            } else {
              return costItem
            }
          } else {
            return costItem
          }
        })
      )

      this.setState({ productData: { ...data, productCost: newData } })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }

    /* const newdata = get(data, 'productCost', []).map(async item => {
      const { data } = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${item.storeName}&components=postal_code:${
          item.zipCode
        }&key=${geoCodeAPIKEy}`,
        {
          headers: {
            Authorization: null
          }
        }
      )
      console.log('productData-------->', data)

      if (results.length !== 0) {
        const geo = results[0].geometry.location
        return { ...item, ...geo }
      } else {
        return item
      }
    }) */

    this.fetchSubstitutes()
  }

  getuserData = async () => {
    const warningQuery = {
      filter: { include: ['diets', 'allergies'] }
    }
    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}?${qs.stringify(warningQuery)}`)
      if (data.haveConflicts === '' || data.haveConflicts === null) {
        this.setState({ showWarningPopUp: true })
      }
      if (data.zipCode === '' || data.zipCode === null) {
        this.setState({ zipcodeWarningCard: true })
      } else {
        this.setState({ zipcodeWarningCard: false })
      }
      this.setState({ userData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }
  getProduct = async () => {
    try {
      const query = {
        filter: {
          where: { productCode: this.props.match.params.tab },
          fields: {
            isHidden: true
          }
        }
      }
      const { data } = await axios.get(`${API_URL}/ProductTables?${qs.stringify(query)}`)
      this.setState({ isHidden: data[0].isHidden })
    } catch (error) {
      console.log(error)
    }
  }

  handleAdd = id => {
    const { shoppingData } = this.state
    this.setState({
      touched: true,
      shoppingData: {
        ...shoppingData,
        [id]: {
          ...shoppingData[id],
          shoppingListId: id,
          userId: Cookies.get('user_id'),
          productCode: this.props.match.params.tab,
          quantity: get(shoppingData[id], 'quantity', 0) + 1
        }
      }
    })
  }
  handleSubtract = id => {
    const { shoppingData } = this.state

    if (shoppingData[id].quantity > 1) {
      this.setState({
        touched: true,
        shoppingData: {
          ...shoppingData,
          [id]: {
            ...shoppingData[id],
            shoppingListId: id,
            userId: Cookies.get('user_id'),
            productCode: this.props.match.params.tab,
            quantity: get(shoppingData[id], 'quantity', 0) - 1
          }
        }
      })
    } else if (shoppingData[id].quantity === 0) {
    } else if (window.confirm('Do you really want to remove the product from the list?')) {
      this.setState({
        touched: true,
        shoppingData: {
          ...shoppingData,
          [id]: {
            ...shoppingData[id],
            shoppingListId: id,
            userId: Cookies.get('user_id'),
            productCode: this.props.match.params.tab,
            quantity: get(shoppingData[id], 'quantity', 0) - 1
          }
        }
      })
    }
  }

  fetchSubstitutes = async () => {
    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            {
              productCode: {
                neq: this.props.match.params.tab
              }
            },
            {
              activeGsSystem: {
                gte: 3
              }
            },
            { productType: this.state.productData.productType },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          productCode: {
            neq: this.props.match.params.tab
          },
          activeGsSystem: {
            gte: 3
          },
          productType: this.state.productData.productType
        }
    const query = {
      filter: {
        include: ['productCost', 'users'],
        where: selectedStoresFilter,
        order: ['totalGs DESC'],
        limit: 10
      }
    }

    const { data } = await axios.get(`${API_URL}/product_cost_details`, {
      params: {
        filter: query.filter
      }
    })

    this.setState({ valuesData: uniqBy(filter(data, item => item.productCost), 'productCode') })
  }

  getBugReport = async () => {
    const query = {
      filter: {
        where: {
          userId: Cookies.get('user_id'),
          productCode: this.props.match.params.tab,
          isDeleted: false
        }
      }
    }
    const queryCount = {
      filter: {
        where: {
          userId: Cookies.get('user_id'),
          productCode: this.props.match.params.tab
        }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserBugReports?${qs.stringify(query)}`)
    const { data: bugCount } = await axios.get(`${API_URL}/UserBugReports?${qs.stringify(queryCount)}`)
    this.setState({ bugReported: data.length > 0 ? true : false, bugCount })
  }
  /* 
  toggleReportBug = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: this.props.match.params.tab }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserBugReports?${qs.stringify(query)}`)
    console.log(data)
    if (data.length === 0) {
      console.log('inside')
      await axios.post(`${API_URL}/UserBugReports`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      this.getBugReport()
    } else {
      await axios.delete(`${API_URL}/UserBugReports/${data[0].id}`)
      this.getBugReport()
    }
  } */

  reportBug = async (id, val = '') => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: this.props.match.params.tab, isDeleted: false }
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserBugReports?${qs.stringify(query)}`)
      if (data.length === 0) {
        await axios.post(`${API_URL}/UserBugReports`, {
          productCode: id,
          description: val.title,
          userId: Cookies.get('user_id'),
          createdAt: new Date()
        })
        this.setState({ openToast2: true })
        setTimeout(() => this.setState({ openToast2: false }), 5000)
        this.getBugReport()
      } else {
        const updateQuery = {
          where: { userId: Cookies.get('user_id'), productCode: this.props.match.params.tab, isDeleted: false }
        }
        await axios.post(`${API_URL}/UserBugReports/update?${qs.stringify(updateQuery)}`, {
          isDeleted: true
        })
        // await axios.delete(`${API_URL}/UserBugReports/${data[0].id}`)
        this.getBugReport()
        this.setState({ bugReportModal: true })
      }
    } catch (error) {
      console.log(error)
    }
  }

  getAllFavouriteData = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?filter=%7B%22fields%22%3A%22productCode%22%7D`
      )
      this.setState({ allFavouriteData: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }

  getFavouriteData = async () => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: this.props.match.params.tab }
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
      this.setState({ favouriteData: data.length })
    } catch (error) {
      console.log('ERROR', error)
    }
  }
  changeFavoriteData = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: id }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
    if (data.length === 0) {
      await axios.post(`${API_URL}/UserProducts`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      this.getFavouriteData()
      this.getAllFavouriteData()
    } else {
      await axios.delete(`${API_URL}/UserProducts/${data[0].id}`)
      this.getFavouriteData()
      this.getAllFavouriteData()
    }
  }

  hideProduct = async (id, isHidden) => {
    const { bugReported } = this.state
    if (isHidden === false && bugReported) {
      this.reportBug(id)
    } else if (isHidden === false && bugReported === false) {
      this.setState({ bugReportModal: true })
    }

    try {
      await axios.patch(`${API_URL}/ProductTables/${id}`, {
        isHidden: !isHidden
      })
      this.getProduct()
    } catch (error) {
      console.log(error)
    }
  }
  // getTotalPrice = data => {
  //   let total = {}
  //   let lowerTotalPrice = 0
  //   let upperTotalPrice = 0
  //   data.forEach(item => {
  //     const priceRange = get(item, 'product.productCost', []).map(ite =>
  //       ite.productPriceSale ? ite.productPriceSale * item.quantity : ite.productPriceOriginal * item.quantity
  //     )
  //     lowerTotalPrice += min(priceRange)
  //     upperTotalPrice += max(priceRange)
  //     total = {
  //       lowerTotalPrice: roundingValue(lowerTotalPrice),
  //       upperTotalPrice: roundingValue(upperTotalPrice)
  //     }
  //   })
  //   console.log('total', total)
  //   return total
  // }

  handleList = async () => {
    try {
      const query = {
        filter: {
          include: [{ products: { product: ['productCost'] } }]
        }
      }
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/shoppingLists?${qs.stringify(query)}`
      )
      await this.setState({ shoppingLists: data })
      // console.log('shoppingLists', this.state.shoppingLists)
      if (isEmpty(this.state.shoppingLists)) {
        this.setState({ showModal: true, openList: true })
      } else {
        await this.setState({ showModal: true, listExist: true })
        try {
          await axios.get(`${API_URL}/users/${Cookies.get('user_id')}/shoppingListProducts`)

          const fetchQuantity = flatten(
            this.state.shoppingLists.map(item =>
              filter(get(item, 'products', []), o => o.productCode === this.props.match.params.tab)
            )
          )
          // console.log('fetchQuantity', fetchQuantity)

          const newFetch = {}

          for (const i of fetchQuantity) {
            newFetch[i.shoppingListId] = i
          }
          this.setState({ shoppingData: newFetch })
          // this.setState({ shoppingData: data })
          // console.log('shoppingListProducts', data)
        } catch (error) {
          console.log('ERROR shoppingListProducts', error)
        }
      }
    } catch (error) {
      console.log('ERROR', error)
    }
  }

  deleteList = async () => {
    const ids = values(this.state.shoppingData).map(item => ({
      id: item.id
    }))

    // dont delete anything if id is not found
    if (!ids[0].id) {
      return
    }

    ids.forEach(async item => {
      try {
        const { data } = await axios.delete(`${API_URL}/usershoppinglistproducts/${item.id}`)
        console.log('data==>', data)
      } catch (error) {
        console.log('error==>', error)
      }
    })
  }

  handleAddToList = async () => {
    await this.setState({ isLoading: true })
    await this.deleteList()
    // console.log('this.state.shoppingData', values(this.state.shoppingData))
    try {
      await axios.post(
        `${API_URL}/users/${Cookies.get('user_id')}/shoppingListProducts`,
        values(lodashMap(this.state.shoppingData, list => omit(list, ['id'])))
      )
      this.setState({
        showModal: false,
        openToast: true,
        isLoading: false,
        listExist: false,
        openList: false,
        createNew: false
      })
      // console.log('DATA', data)
    } catch (error) {
      await this.setState({ isLoading: false })
      console.log('error', error)
    }
  }
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openToastTwo: false })
    this.setState({ openToast: false })
  }

  copyToClipboard = async copyText => {
    console.log({ copyText })
    try {
      const el = document.createElement('textarea')
      el.value = copyText
      document.body.appendChild(el)
      el.select()
      await document.execCommand('copy')
      document.body.removeChild(el)
      this.setState({ success: 'Copied to clipboard' })
    } catch (err) {
      console.log(err)
    }
  }

  setDietaryConflicts = async value => {
    try {
      await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}`, {
        haveConflicts: value ? true : false
      })
      this.setState({ showWarningPopUp: false })
      if (value) {
        this.props.history.push({
          pathname: '/dashboard/dietary-preference',
          state: {
            productCode: this.props.match.params.tab
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  updateZipcode = async () => {
    try {
      await axios.post(`${API_URL}/users/update-zipcode`, {
        userId: Cookies.get('user_id'),
        lat: get(this.props, 'coords.latitude', '').toString(),
        long: get(this.props, 'coords.longitude', '').toString()
      })
      this.getuserData()
    } catch (error) {
      console.log(error)
    }
  }

  createMarkeup = content => ({
    __html: content
  })
  onStoreChange = () => {
    //get stores
    const selectedStores = Cookies.getJSON('selectedStores')
    // change state to the selected stores
    this.setState({ selectedStores }, this.componentDidMount)
    // change the filters
  }
  componentDidUpdate(prevProps) {
    // console.log(this.props.match)
    if (this.props.match.params.tab !== prevProps.match.params.tab) {
      this.componentDidMount()
    }
  }

  handleToggle = key => {
    let toggleImage = this.state.toggleImage
    toggleImage[key] = !toggleImage[key]
    this.setState({ toggleImage: toggleImage })
  }

  render() {
    const {
      location: { pathname },
      match: {
        params: { tab }
      }
    } = this.props
    const urlArr = window.location.href.split('/')
    const pUrl = urlArr[0] + '//' + urlArr[2]

    const {
      productData,
      userData,
      shoppingLists,
      favouriteData,
      allFavouriteData,
      bugReported,
      shoppingData,
      isLoading,
      valuesData,
      shareModal,
      isImgPreviewOpen,
      bugCount,
      isHidden,
      showWarningPopUp,
      zipcodeWarningCard,
      dietaryWarningCard
    } = this.state
    const favouriteDataz = flatMap(allFavouriteData, 'productCode')
    const greenScore = {
      animalWelfare: get(productData, 'greenScores.animalWelfare', null),
      environment: get(productData, 'greenScores.environment', null),
      foodSafety: get(productData, 'greenScores.foodSafety', null),
      nutrition: get(productData, 'greenScores.nutrition', null),
      processing: get(productData, 'greenScores.processing', null),
      transparency: get(productData, 'greenScores.transparency', null),
      humanRights: get(productData, 'greenScores.humanRights', null)
    }

    const data = Object.values(pickBy(greenScore, o => o !== null && o !== ''))
    const scores = [
      greenScore.foodSafety,
      greenScore.transparency,
      greenScore.animalWelfare,
      greenScore.humanRights,
      greenScore.environment,
      greenScore.nutrition,
      greenScore.processing
    ]

    const uniqueDescriptions = get(productData, 'gsDescriptions', [])
    // const nullText = 'This product does not have sufficient information in order to generate a reliable score.'
    const greenDescriptions = {
      animalWelfare: filter(uniqueDescriptions, o => o.gsSystem === 'animal_welfare'),
      environment: filter(uniqueDescriptions, o => o.gsSystem === 'environment'),
      foodSafety: filter(uniqueDescriptions, o => o.gsSystem === 'food_safety'),
      nutrition: filter(uniqueDescriptions, o => o.gsSystem === 'nutrition'),
      processing: filter(uniqueDescriptions, o => o.gsSystem === 'processing'),
      transparency: filter(uniqueDescriptions, o => o.gsSystem === 'transparency'),
      humanRights: filter(uniqueDescriptions, o => o.gsSystem === 'human_rights')
    }

    const greenDsc = [
      {
        category: 'processing',
        description: greenDescriptions.processing
      },
      {
        category: 'nutrition',
        description: greenDescriptions.nutrition
      },
      {
        category: 'food_safety',
        description: greenDescriptions.foodSafety
      },
      {
        category: 'animal_welfare',
        description: 'This scoring system is still under development.'
      },
      {
        category: 'environment',
        description: greenDescriptions.environment
      },
      {
        category: 'human_rights',
        description: 'This scoring system is still under development.'
      },
      { category: 'transparency', description: 'This scoring system is still under development.' }
    ]

    const productCode = get(productData, 'productCode', '')

    const { showModal, openList, createNew, listExist, openToast, touched } = this.state
    const productQuantity = get(productData, 'productCost', '')[0]

    const priceRange = get(productData, 'productCost', []).map(item =>
      item.productPriceSale ? item.productPriceSale : item.productPriceOriginal
    )

    const userDiets = get(userData, 'diets', []).map(item => lowerCase(item.diet))
    const userAllergies = get(userData, 'allergies', []).map(item => lowerCase(item.allergy))
    const allergyConflicts = get(productData, 'allergyConflicts', '')
      .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
      .toLowerCase()
      .split(',')
      .map(item => item.trim())
    const dietConflicts = get(productData, 'dietConflicts', '')
      .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
      .toLowerCase()
      .split(',')
      .map(item => item.trim())

    if (
      !isEmpty(productData) &&
      (get(this.state, 'userData.zipCode', null) === '' || get(this.state, 'userData.zipCode', null) === null) &&
      get(this.props, 'coords.latitude', null) !== null
    ) {
      this.updateZipcode()
    }

    return (
      <React.Fragment>
        <Header
          title={truncate(upperlower(productData.productName, 'titlecase'), { length: 25 }) || 'NA'}
          icon="arrowBack"
          color="#fff"
          zIndex={isImgPreviewOpen ? '0' : '9'}
          onClickBack={() =>
            Cookies.get('access_token') === undefined
              ? Cookies.set('previousPath', pathname, { path: '/' }) &&
                this.props.history.push({ pathname: '/auth/signup', previousPath: pathname })
              : isEmpty(get(this.state, 'recievedState', {}))
              ? this.props.history.goBack()
              : this.props.history.push({
                  pathname: get(this.state.recievedState, 'lastPath', ''),
                  state: {
                    shopInStoreMode: get(this.state.recievedState, 'shopInStoreMode', false),
                    cardIndex: get(this.state.recievedState, 'cardIndex', 0),
                    checkboxes: get(this.state.recievedState, 'checkboxes', []),
                    scrolledToBottom: get(this.state.recievedState, 'scrolledToBottom', false),
                    showModal: get(this.state.recievedState, 'showModal', false),
                    replacementList: get(this.state.recievedState, 'replacementList', false),
                    originalProduct: get(this.state.recievedState, 'originalProduct', []),
                    radioButtonProductCode: get(this.state.recievedState, 'radioButtonProductCode', ''),
                    substitutesProducts: get(this.state.recievedState, 'substitutesProducts', ''),
                    storeName: get(this.state.recievedState, 'storeName', '')
                  }
                })
          }
          leftIcon="share"
          onClickLeft={() => this.setState({ shareModal: true })}
        />
        <SecondaryHeader clicked={this.onStoreChange} padding="70px 16px 0" />
        <PageWrapper viewPadding="14px 4.3% 84px" height="auto">
          {/* {this.state.dietaryWarningCard && get(this.state.userData, 'diets', []).length === 0 && (
          <WarningCard
            onClickCard={() => this.props.history.push('/dashboard/dietary-preference/edit')}
            onClose={() => this.setState({ dietaryWarningCard: false })}
            text="Have dietary restrictions? Tell us and we'll scan products for conflicts with your allergy or diet."
          />
        )} */}

          {dietaryWarningCard &&
            get(this.state.userData, 'haveConflicts', null) === true &&
            get(this.state.userData, 'diets', []).length === 0 && (
              <WarningCard
                onClickCard={() =>
                  this.props.history.push({
                    pathname: '/dashboard/dietary-preference',
                    state: {
                      productCode: this.props.match.params.tab
                    }
                  })
                }
                onClose={() => this.setState({ dietaryWarningCard: false })}
                text="Have dietary restrictions? Tell us and we'll scan products for conflicts with your allergy or diet."
              />
            )}
          {dietaryWarningCard &&
            get(this.state.userData, 'haveConflicts', null) === true &&
            get(this.state.userData, 'diets', []).length > 0 &&
            get(this.state.userData, 'allergies', []).length === 0 && (
              <WarningCard
                onClickCard={() =>
                  this.props.history.push({
                    pathname: '/dashboard/allergies',
                    state: {
                      productCode: this.props.match.params.tab
                    }
                  })
                }
                onClose={() => this.setState({ dietaryWarningCard: false })}
                text="Have allergy restrictions? Tell us and we'll scan products for conflicts with your allergy or diet."
              />
            )}
          {zipcodeWarningCard && (
            <WarningCard
              onClickCard={() => this.props.history.push('/dashboard/zipcode/edit')}
              onClose={() => this.setState({ zipcodeWarningCard: false })}
              text="We could not identify your zipcode, click here to update."
            />
          )}
          <Card
            boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
            borderRadius="5px"
            bgColor="#fff"
            margin="0 0 30px 0"
            padding="10px 10px 16px 10px"
            style={{ zIndex: 1 }}>
            <FlexWrapper direction="row" justifyContent="space-between" height="44px">
              <FlexWrapper direction="column" justifyContent="space-between" height="100px" width="0">
                <Favorite
                  position="static"
                  active={favouriteData}
                  onClick={() => this.changeFavoriteData(tab)}
                  hideFavCount={favouriteData === 0}
                  favValue={get(productData, 'users', {}) ? get(productData, 'users', {}).length : 0}
                />
                {isAdmin() && (
                  <Hidden position="static" active={isHidden} onClick={() => this.hideProduct(tab, isHidden)} />
                )}
              </FlexWrapper>
              <FlexWrapper alignItems="center">
                {isEmpty(intersection(userAllergies, allergyConflicts)) &&
                isEmpty(intersection(userDiets, dietConflicts)) ? null : (
                  <Tooltip onClick={() => this.setState({ showModal: true })} margin="0 auto" />
                )}
              </FlexWrapper>
              <ProgressBar strokeWidth={16} size="43px" percentage={round(sum(data) / data.length) || 0} />
            </FlexWrapper>
            <FlexWrapper direction="row" justifyContent="space-between">
              <ImageModal
                onTouchImage={() => this.setState({ isImgPreviewOpen: true })}
                onClose={() => this.setState({ isImgPreviewOpen: false })}
                caption={'Product Image'}
                image={
                  isEmpty(productData.productImage)
                    ? require('../static/images/no-image.png')
                    : productData.productImage
                }
                /* large={
                  isEmpty(productData.productImage)
                    ? require('../static/images/no-image.png')
                    : productData.productImage
                } */
                height="156px"
                alt="Product Image"
              />
              <BugBox fillBug={bugCount}>
                <Favorite
                  position="static"
                  icon="newBug"
                  active={bugCount}
                  fill="red"
                  color="red"
                  hideFavCount
                  onClick={
                    bugReported
                      ? () => this.reportBug(this.props.match.params.tab)
                      : () => this.setState({ bugReportModal: true })
                  }
                />
              </BugBox>
            </FlexWrapper>
            <XMText color="#9a9a9a">
              {size(get(productQuantity, 'productQuantity', '')) < 15
                ? toUpper(get(productQuantity, 'productQuantity', ''))
                : ''}
            </XMText>
            <XXLText textAlign="left" color="#124b5f">
              {upperlower(productData.productName, 'titlecase')}
            </XXLText>
            <FlexWrapper direction="row" justifyContent="space-between" alignItems="center">
              <XXXLText fontWeight="600" color="#078489" fontFamily="Overpass">
                {priceRange[0] === null ? '$na.na' : priceRangeCalculator(priceRange)}
              </XXXLText>
              <Shape onClick={() => this.handleList()} margin="0 0 0 auto">
                <Icon icon="addToList" />
                <DefaultText color="#124b5f">Add to list</DefaultText>
              </Shape>
            </FlexWrapper>
          </Card>

          <Card padding="20px 18px 24px" bgColor="#fff" boxShadow="0 0 2px 0 rgba(0, 0, 0, 0.25)" style={{ zIndex: 0 }}>
            <Tabber>
              <Tab
                replace
                onClick={() => this.setState({ selectedTab: `/products/${tab}/green-score` })}
                to={`/products/${tab}/green-score`}
                selected={pathname === `/products/${tab}/green-score`}>
                GreenScore
              </Tab>
              <Tab
                replace
                onClick={() => this.setState({ selectedTab: `/products/${tab}/basic-info` })}
                to={`/products/${tab}/basic-info`}
                selected={pathname === `/products/${tab}/basic-info`}>
                Basic Info
              </Tab>
              <Tab
                replace
                onClick={() => this.setState({ selectedTab: `/products/${tab}/grocery-store` })}
                to={`/products/${tab}/grocery-store`}
                selected={pathname === `/products/${tab}/grocery-store`}>
                Stores
              </Tab>
            </Tabber>
            {pathname === `/products/${tab}/green-score` && !isEmpty(productData) && (
              <PieChart productCode={productCode} scores={scores} descriptions={greenDsc} />
            )}
            {pathname === `/products/${tab}/basic-info` && (
              <React.Fragment>
                <React.Fragment>
                  <DefaultText fontWeight={'bold'} color="#124b5f">
                    Ingredients
                  </DefaultText>
                  <XLMText overflowWrap="break-word" color="#124b5f">
                    {capitalize(get(productData, 'ingredientList', ''))}
                  </XLMText>
                  <br />
                </React.Fragment>
                <DefaultText fontWeight={'bold'} color="#124b5f">
                  Description
                </DefaultText>
                <XLMText color="#124b5f">{capitalize(get(productData, 'productDescription', ''))}</XLMText>
              </React.Fragment>
            )}
            {pathname === `/products/${tab}/grocery-store` && (
              <React.Fragment>
                {get(productData, 'productCost', []).map(item => {
                  return (
                    <StyledFlex direction="row" alignItems="center" viewPadding="16px 0">
                      <FlexWrapper direction="row" alignItems="center" flexBasis="80%">
                        {isEmpty(get(item, 'grocer', '')) ? (
                          <StyledImage height="62px" src={require('../static/images/no-image.png')} alt="food" />
                        ) : (
                          <StyledImage
                            height="62px"
                            maxWidth="62px"
                            src={
                              get(item.grocer, 'imageUrl', '') === null
                                ? require('../static/images/no-image.png')
                                : get(item.grocer, 'imageUrl', '')
                            }
                            alt="food"
                          />
                        )}
                        <FlexWrapper viewPadding="0 0 0 20px">
                          <FlexWrapper direction="row" alignItems="center">
                            <XMText>{upperlower(item.storeName.replace('Insta_', ''), 'titlecase')}</XMText>
                            {item.productPriceSale === null ? '' : <Sale />}
                          </FlexWrapper>
                          {!item.zipCode ? '' : <XLMMText color="#9f9f9f">Zip Code: {item.zipCode}</XLMMText>}
                          <FlexWrapper direction="row" alignItems="center">
                            {get(item.grocer, 'grocerType', '') === 'Online' ? (
                              <React.Fragment>
                                <Shape
                                  display="inline-flex"
                                  padding="2px 4px"
                                  backgroundColor="#fff"
                                  border="1px solid #00aada"
                                  margin="0 4px 0 0"
                                  borderRadius="18px"
                                  justifyContent="center">
                                  {/* <Icon icon="distance" /> */}
                                  <XXMText color="#00aada">Online</XXMText>
                                </Shape>
                                {/*  <div>
                                    {!this.props.isGeolocationAvailable ? (
                                      <XXMText>Your browser does not support Geolocation</XXMText>
                                    ) : !this.props.isGeolocationEnabled ? (
                                     
                                    ) : this.props.coords ? (
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>latitude</td>
                                            <td>{this.props.coords.latitude}</td>
                                          </tr>
                                          <tr>
                                            <td>longitude</td>
                                            <td>{this.props.coords.longitude}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    ) : (
                                      ''
                                    )}
                                  </div> */}
                              </React.Fragment>
                            ) : get(item.grocer, 'grocerType', '') === 'Insta' ? (
                              <Shape
                                display="inline-flex"
                                padding="2px 4px"
                                backgroundColor="#fff"
                                border="1px solid #00aada"
                                margin="0 4px 0 0"
                                borderRadius="18px"
                                justifyContent="center">
                                {get(item.grocer, 'distance', null) ? (
                                  <React.Fragment>
                                    <Icon icon="distance" />
                                    <XXMText color="#00aada">
                                      {`${(get(item.grocer, 'distance', 0) / 1609.344).toFixed(2)} mi` || 'Online'}
                                    </XXMText>
                                  </React.Fragment>
                                ) : (
                                  <XXMText color="#00aada">Online</XXMText>
                                )}
                              </Shape>
                            ) : get(item.grocer, 'grocerType', '') === 'Mixed' ? (
                              <Shape
                                display="inline-flex"
                                padding="2px 4px"
                                backgroundColor="#fff"
                                border="1px solid #00aada"
                                margin="0 4px 0 0"
                                borderRadius="18px"
                                justifyContent="center">
                                {get(item.grocer, 'distance', null) ? (
                                  <React.Fragment>
                                    <Icon icon="distance" />
                                    <XXMText color="#00aada">
                                      {`${(get(item.grocer, 'distance', 0) / 1609.344).toFixed(2)} mi` || 'Online'}
                                    </XXMText>
                                  </React.Fragment>
                                ) : (
                                  <XXMText color="#00aada">Online</XXMText>
                                )}
                              </Shape>
                            ) : (
                              <Shape
                                display="inline-flex"
                                padding="2px 4px"
                                backgroundColor="#fff"
                                border="1px solid #00aada"
                                margin="0 4px 0 0"
                                borderRadius="18px"
                                justifyContent="center">
                                {get(item.grocer, 'distance', null) ? (
                                  <React.Fragment>
                                    <Icon icon="distance" />
                                    <XXMText color="#00aada">
                                      {`${(get(item.grocer, 'distance', 0) / 1609.344).toFixed(2)} mi` || 'Offline'}
                                    </XXMText>
                                  </React.Fragment>
                                ) : (
                                  <XXMText color="#00aada">Offline</XXMText>
                                )}
                              </Shape>
                            )}

                            {/* <Shape
                              display="inline-flex"
                              padding="0px 2px 0 0"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              Icon icon="distance" /> 
                              <XXMText color="#00aada">Online</XXMText>
                            </Shape> */}
                            {/* <XXMText color="#9f9f9f">Open till 10.00pm</XXMText> */}
                          </FlexWrapper>
                        </FlexWrapper>
                      </FlexWrapper>
                      <FlexWrapper flexBasis="20%">
                        {item.productPriceSale === null ? (
                          ''
                        ) : (
                          <XLMMText color="#c4c4c4" textDecoration="line-through">
                            $
                            {get(item, 'productPriceOriginal', 0) === null
                              ? 'na.na'
                              : item.productPriceOriginal.toFixed(2)}
                          </XLMMText>
                        )}
                        {item.productPriceSale !== null ? (
                          ''
                        ) : item.productPriceOriginal !== null ? (
                          <XLMText color="#078489">${item.productPriceOriginal.toFixed(2)}</XLMText>
                        ) : (
                          <XLMText color="#078489">${'na.na'}</XLMText>
                        )}
                      </FlexWrapper>
                    </StyledFlex>
                  )
                })}
              </React.Fragment>
            )}
          </Card>
          {!isEmpty(filterHiddenData(valuesData)) && (
            <React.Fragment>
              <TopSection title="Shoppers also looked at" padding="30px 16px 0 5px" />
              <CustomSlider
                itemWidth={154}
                numberOfItems={get(filterHiddenData(valuesData), 'length')}
                margin="10px 5px">
                {filterHiddenData(valuesData).map((item, index) => {
                  /*  const priceRange = get(item, 'productCost', []).map(range => {
                    return {
                      value: range.productPriceSale ? range.productPriceSale : range.productPriceOriginal,
                      zipCode: range.zipCode
                    }
                  }) */
                  const priceRange = get(item, 'productCost', []).map(range =>
                    range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                  )

                  console.log(item.productCode, priceRange)

                  const allergyConflicts = get(item, 'allergyConflicts', '')
                    .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                    .toLowerCase()
                    .split(',')
                    .map(item => item.trim())
                  const dietConflicts = get(item, 'dietConflicts', '')
                    .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                    .toLowerCase()
                    .split(',')
                    .map(item => item.trim())

                  return (
                    <CardParent key={index}>
                      <Favorite
                        active={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                        onClick={() => this.changeFavoriteData(item.productCode)}
                        hideFavCount={get(item, 'users', 0).length === 0}
                        favValue={item.users ? item.users.length : 0}
                        zIndex={isImgPreviewOpen ? '0' : '8'}
                        top="10px"
                      />
                      {isAdmin() && item.isHidden && <Hidden top="45px" active={true} />}
                      <a
                        onClick={async () => {
                          if (Cookies.get('access_token') === undefined) {
                            Cookies.set('previousPath', pathname, { path: '/' })
                            this.props.history.push({
                              pathname: '/auth/signup',
                              previousPath: pathname
                            })
                          } else {
                            await Cookies.set('currentPage', `/products/${item.productCode}/green-score`, {
                              path: '/',
                              expires: 365
                            })
                            this.props.history.push({ pathname: `/products/${item.productCode}/green-score` })
                          }
                        }}
                        key={index}>
                        {/*
                      <Shape
                        display="inline-flex"
                        padding="2px 6px"
                        backgroundColor="#fff"
                        boxShadow="0 0 2px 0 rgba(0, 0, 0, 0.25)"
                        position="absolute"
                        justifyContent="center">
                        <XLMMText color="#9a9a9a">Top Score</XLMMText>
                      </Shape>
                     */}

                        <Card
                          boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                          borderRadius="5px"
                          bgColor="#fff"
                          margin="0 0 0 0"
                          height="218px"
                          padding="10px"
                          style={{ zIndex: 0 }}>
                          <FlexChild>
                            <FlexWrapper direction="row" justifyContent="flex-end">
                              {!isEmpty(intersection(userAllergies, allergyConflicts)) ||
                                (!isEmpty(intersection(userDiets, dietConflicts)) && (
                                  <Tooltip padding="2px 4px" forProductView margin="0 auto 0 35%" />
                                ))}
                              <ProgressBar
                                strokeWidth={16}
                                size="36px"
                                percentage={Math.round(item.totalGs, 0) || 'NA'}
                                fill={'#ffd33d'}
                                backgroundFilled
                              />
                            </FlexWrapper>
                            <div>
                              <StyledImage
                                maxWidth="100%"
                                objectFit="cover"
                                src={
                                  isEmpty(item.productImage)
                                    ? require('../static/images/no-image.png')
                                    : item.productImage
                                }
                                height="85px"
                                alt="food"
                              />
                            </div>
                            <FlexWrapper viewPadding="0">
                              <XMText color="#9a9a9a" minHeight="21px">
                                {size(get(item, 'productQuantity', '')) < 15
                                  ? toUpper(get(item, 'productQuantity', ''))
                                  : ''}
                              </XMText>
                              <XMText color="#124b5f" minHeight="40px">
                                {upperlower(truncate(get(item, 'productName', ''), { length: 26 }), 'titlecase')}
                              </XMText>
                              <DefaultText color="#078489" style={{ height: '21px' }}>
                                {priceRange[0] === null ? '$na.na' : priceRangeCalculator(priceRange)}
                              </DefaultText>
                            </FlexWrapper>
                          </FlexChild>
                        </Card>
                      </a>
                    </CardParent>
                  )
                })}
              </CustomSlider>
            </React.Fragment>
          )}
        </PageWrapper>
        <Footer zIndex={isImgPreviewOpen ? '0' : '9'} />
        <Modal
          title={openList || listExist ? 'Add to List' : createNew ? 'Create New List' : 'Dietary Warnings'}
          show={showModal}
          hide={!showModal}
          list={openList || listExist}
          onClose={() => this.setState({ showModal: false, openList: false, createNew: false, listExist: false })}>
          <FlexWrapper alignItems="center">
            {openList ? (
              <Shape onClick={() => this.setState({ createNew: true, openList: false })}>
                <Icon icon="addToList" />
                <XXLText textAlign="left" color="#124b5f">
                  Create New List
                </XXLText>
              </Shape>
            ) : createNew ? (
              <React.Fragment>
                <Formik
                  enableReinitialize
                  initialValues={{ title: '' }}
                  validate={addList}
                  validateOnChange
                  onSubmit={async val => {
                    try {
                      await axios.post(`${API_URL}/users/${Cookies.get('user_id')}/shoppingLists`, {
                        name: val.title,
                        userId: Cookies.get('user_id')
                      })
                      await this.setState({ showModal: false, createNew: false })
                      this.handleList()
                      // await this.setState({ listExist: true, showModal: true })
                    } catch (error) {
                      console.log('ERROR', error)
                    }
                  }}
                  render={formikBag => (
                    <FormikForm>
                      <Field
                        name="title"
                        render={({ field }) => (
                          <TextField {...field} width="auto" type="text" label="Title" error={formikBag.errors.title} />
                        )}
                      />
                      <FlexWrapper alignItems="center">
                        <Button
                          size="small"
                          label="Add"
                          namespace="Create List"
                          volume="filled"
                          margin="14px 0 0 0"
                          type="submit"
                        />
                      </FlexWrapper>
                    </FormikForm>
                  )}
                />
              </React.Fragment>
            ) : listExist ? (
              <ListView
                hideTop={
                  <FlexWrapper
                    direction="row"
                    alignItems="center"
                    viewPadding="0 0 10px 0"
                    onClick={async () => {
                      await this.setState({ showModal: false, listExist: false })
                      this.setState({ showModal: true, createNew: true })
                    }}>
                    <FlexWrapper viewMargin="0 6px 0 0" flexBasis="6%">
                      <Icon icon="addToList" />
                    </FlexWrapper>
                    <XLMText color="#124b5f">Create New List</XLMText>
                  </FlexWrapper>
                }
                showButton={
                  <Button
                    size="small"
                    label="Confirm"
                    namespace="Add Item List"
                    volume="filled"
                    margin="14px 0 0 0"
                    disabled={!touched || isLoading}
                    isLoading={isLoading}
                    onClick={() => this.handleAddToList()}
                  />
                }
                component={shoppingLists.map(list => {
                  const showImageComponent = this.state.toggleImage[list.id] ? true : false
                  return (
                    <React.Fragment key={list.id}>
                      <FlexWrapper direction="row" alignItems="center">
                        <ProgressBar
                          onClick={() => this.handleToggle(list.id)}
                          flex
                          percentage={
                            getAverageData(get(list, 'products', 0)) === 'NaN'
                              ? 0
                              : getAverageData(get(list, 'products', 0))
                          }
                          initialAnimation={true}
                          strokeWidth={16}
                          size="52px"
                          childComponent={
                            !showImageComponent && (
                              <StyledImage
                                src={get(
                                  list.products[0],
                                  'product.productImage',
                                  require('../static/images/empty-list.png')
                                )}
                                height="32px"
                                maxWidth="32px"
                                style={{ position: 'absolute', borderRadius: '50%' }}
                                background="#fff"
                              />
                            )
                          }
                        />

                        <StyledFlex
                          direction="row"
                          viewMargin="0 0 0 20px"
                          viewPadding="16px 0"
                          alignItems="center"
                          justifyContent="space-between">
                          <FlexWrapper flexBasis="80%">
                            <TextOverflow>
                              <XXLText
                                textAlign="left"
                                color="#124b5f"
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '120px'
                                }}>
                                {list.name}
                              </XXLText>
                              <FlexWrapper direction="row" alignItems="center">
                                <XMText color="#9f9f9f">
                                  {sum(get(list, 'products', []).map(item => item.quantity)) || 0} items
                                </XMText>
                                {/* <XMText color="#9f9f9f" padding="0 0 0 2px">
                                    |
                                  </XMText>
                                  <XMText color="#078489" fontWeight="600" padding="0 0 0 2px">
                                    $
                                    {get(this.getTotalPrice(get(list, 'products', [])), 'lowerTotalPrice', '') ===
                                    get(this.getTotalPrice(get(list, 'products', [])), 'upperTotalPrice', '')
                                      ? get(this.getTotalPrice(get(list, 'products', [])), 'upperTotalPrice', '')
                                      : `${get(
                                          this.getTotalPrice(get(list, 'products', [])),
                                          'lowerTotalPrice',
                                          ''
                                        )} - ${get(
                                          this.getTotalPrice(get(list, 'products', [])),
                                          'upperTotalPrice',
                                          ''
                                        )}`}
                                  </XMText> */}
                              </FlexWrapper>
                            </TextOverflow>
                          </FlexWrapper>
                          <Counter
                            disableDelete={get(shoppingData[list.id], 'quantity', 0) === 0}
                            value={get(shoppingData[list.id], 'quantity', 0) || 0}
                            onAdd={() => this.handleAdd(list.id)}
                            onSubtract={() => this.handleSubtract(list.id)}
                          />
                        </StyledFlex>
                      </FlexWrapper>
                    </React.Fragment>
                  )
                })}
              />
            ) : (
              <React.Fragment>
                {!isEmpty(intersection(userAllergies, allergyConflicts)) && (
                  <FlexWrapper>
                    <XLMText fontWeight={600}>Allergy Conflict:</XLMText> This product conflicts with your allergy to{' '}
                    {join(intersection(userAllergies, allergyConflicts), ', ')}
                  </FlexWrapper>
                )}
                {!isEmpty(intersection(userDiets, dietConflicts)) && (
                  <FlexWrapper>
                    <XLMText fontWeight={600}>Diet Conflict:</XLMText> This product conflicts with your{' '}
                    {join(intersection(userDiets, dietConflicts), ', ')} diet(s).
                  </FlexWrapper>
                )}
                {/* <Button
                  size="small"
                  label="Done"
                  volume="filled"
                  margin="14px 0 0 0"
                  // onClick={() => this.props.history.push('/auth/social-login')}
                /> */}
              </React.Fragment>
            )}
          </FlexWrapper>
        </Modal>

        <Toast open={openToast} message="Products added successfully" onClose={this.handleClose} />
        <Toast
          open={this.state.openToast2}
          slideFromTop
          message="Thanks for alerting us of the issue!"
          onClose={this.handleClose}
        />

        {/* naved */}
        <Modal
          minHeight="180px"
          title={'Bug Report '}
          show={this.state.bugReportModal}
          hide={!this.state.bugReportModal}
          onClose={() => this.setState({ bugReportModal: false, bugFill: false })}>
          <FlexWrapper alignItems="center">
            <React.Fragment>
              <Formik
                enableReinitialize
                initialValues={{ title: '' }}
                onSubmit={async val => {
                  await this.reportBug(this.props.match.params.tab, val)
                  this.setState({ bugReportModal: false })
                }}
                render={formikBag => (
                  <FormikForm>
                    <Field
                      name="title"
                      render={({ field }) => (
                        <TextField {...field} width="auto" type="text" label="Description" autoComplete="off" />
                      )}
                    />
                    <FlexWrapper alignItems="center">
                      <Button
                        size="small"
                        label="Submit"
                        namespace="Report Bug"
                        volume="filled"
                        margin="14px 0 0 0"
                        type="submit"
                      />
                    </FlexWrapper>
                  </FormikForm>
                )}
              />
            </React.Fragment>
          </FlexWrapper>
        </Modal>

        {/*end naved */}

        <Modal
          title={'Share'}
          show={shareModal}
          hide={!shareModal}
          onClose={() => this.setState({ shareModal: false })}>
          <FlexWrapper alignItems="center">
            <FlexWrapper
              viewPadding="0px 30px"
              height={'calc(100% - 50%)'}
              alignItems="center"
              justifyContent="space-evenly">
              <FlexWrapper justifyContent="center" alignItems="center" viewPadding="0 0 0px">
                <XCMText>Share product link</XCMText>
              </FlexWrapper>
              <FlexWrapper direction="row" alignItems="center" justifyContent="space-between" viewPadding="0 0 0 0">
                <StyledImage
                  alt="social"
                  height="44px"
                  src={require('../static/svgs/message.svg')}
                  onClick={() => {
                    window.open(`sms:?&body=${pUrl}${this.props.location.pathname}`)
                  }}
                />
                <StyledImage
                  alt="social"
                  height="44px"
                  src={require('../static/svgs/facebook.svg')}
                  onClick={() => {
                    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pUrl}${this.props.location.pathname}`)
                  }}
                />
                <StyledImage
                  alt="social"
                  height="44px"
                  src={require('../static/svgs/email.svg')}
                  onClick={() => {
                    window.location.href = `mailto:?body=${pUrl}${this.props.location.pathname}`
                  }}
                />

                <StyledImage
                  alt="social"
                  height="44px"
                  src={require('../static/svgs/whatsapp.svg')}
                  onClick={() => {
                    window.location.href = `https://wa.me/?text=Hi%20there!%20${pUrl}${this.props.location.pathname}`
                  }}
                />
              </FlexWrapper>
            </FlexWrapper>
          </FlexWrapper>
        </Modal>
        <Modal title="We Offer Dietary Warnings" show={showWarningPopUp} hide={!showWarningPopUp}>
          <FlexWrapper alignItems="center">
            <XMText>Do you have any dietary restrictions?</XMText>
            <FlexWrapper viewPadding="10px 0 0" direction="row" justifyContent="space-evenly">
              <Button label="Yes" volume="filled" size="small" onClick={() => this.setDietaryConflicts(true)} />
              <Button label="No" volume="filled" size="small" onClick={() => this.setDietaryConflicts(false)} />
            </FlexWrapper>
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false
  }
})(SingleProduct)



// WEBPACK FOOTER //
// ./src/pages/SingleProduct.js